import { render, staticRenderFns } from "./form-queries.vue?vue&type=template&id=841ee7ca&"
import script from "./form-queries.vue?vue&type=script&lang=js&"
export * from "./form-queries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-queries.vue"
export default component.exports